export default __webpack_public_path__ + "static/media/bg3.fc7d506d.png";